import { render, staticRenderFns } from "./ProductsSearchPage.vue?vue&type=template&id=4e846cc3&scoped=true"
import script from "./ProductsSearchPage.vue?vue&type=script&lang=js"
export * from "./ProductsSearchPage.vue?vue&type=script&lang=js"
import style0 from "./ProductsSearchPage.vue?vue&type=style&index=0&id=4e846cc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e846cc3",
  null
  
)

export default component.exports